import React from 'react';

const LinearIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='currentColor'>
    <path d='M0 14.846l9.154 9.154.023-9.177L0 14.846zm.023-5.67L9.2.001 9.177 9.2.023 9.177zM14.846 24L24 14.846l-9.177.023L14.846 24zm-.023-14.8L9.2 14.846l5.623 5.623 5.623-5.623-5.623-5.623zM14.823 0L5.646 9.177l9.177-.023L14.823 0z' />
  </svg>
);

export default LinearIcon;
